import { OffScreen } from '@/js/OffScreen.js'
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
// import config from 'config'
import { MaterialList } from "@/js/Const.js";


// ツールボタンのタイプ
const ToolButtonType = {
    select: 1,
    remove: 2,
    grid: 3,
    ripuup: 4,
    ripudown: 5,
    preview: 6,
    control: 7,
    zoom: 8,
    border: 9,
};
const C02ProductParameter = [
    "product_id",
    "product_name",
    "product_info",
    "front_image_path",
    "front_image_path_mono",
    "front_image_path_preview",
    "front_image_path_outline",
    "front_rib",
    "back_image_path",
    "back_image_path_mono",
    "back_image_path_preview",
    "back_rib",
    "tag_type",
    "tag_image_path",
    "tag_image_path_mono",
    "product_price",
    "paint_price_1",
    "paint_price_2",
    "tag_price",
    "quantity",
    "price_base",
    "margin",
    "margin_inctax",
    "tax_rate",
    "tax",
    "price",
    "price_inctax",
    "product_class_id",
    "classcategory_id1",
    "classcategory_id2",
]

// ツールボタン一つに当てるクラス
class ToolButtonData {
    constructor(a) {
        this.toolButtonType = a;
    }
    getImagePath(flag = false, onFlag = false) {
        switch (this.toolButtonType) {
            case ToolButtonType.select:
                return require('@/assets/tool_select.png');
            case ToolButtonType.remove:
                return require('@/assets/tool_remove.png');
            case ToolButtonType.grid:
                if (flag) {
                    return require('@/assets/btn/grid_on.png');
                } else {
                    return require('@/assets/btn/grid_off.png');
                }

            case ToolButtonType.ripuup:
                return require('@/assets/tool_ripuup.png');
            case ToolButtonType.ripudown:
                return require('@/assets/tool_ripudown.png');
            case ToolButtonType.preview:
                if (flag) {
                    return require('@/assets/btn/preview_on.png');
                } else {
                    return require('@/assets/btn/preview_off.png');
                }
            case ToolButtonType.control:
                if (flag) {
                    return require('@/assets/btn/control_on.png');
                } else {
                    return require('@/assets/btn/control_off.png');
                }
            case ToolButtonType.zoom:
                if (flag) {
                    if (onFlag) {
                        return require('@/assets/btn/zoom_off.png');
                    } else {
                        return require('@/assets/btn/zoom_on.png');
                    }
                } else {
                    return require('@/assets/btn/zoom_disable.png');
                }
            case ToolButtonType.border:
                if (flag) {
                    if (onFlag) {
                        return require('@/assets/btn/border_off.png');
                    } else {
                        return require('@/assets/btn/border_on.png');
                    }
                } else {
                    return require('@/assets/btn/border_disable.png');
                }
        }
    }
}
class Common {
    static async getTagBlobsFromFile(file) {
        if (file.type.startsWith("image/")) {
            var src = window.URL.createObjectURL(file);
        }
        let img = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = src;
        });
        let tagmaskimg = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = require('@/assets/tagmask.png');
        });
        //中央で分割して２マイにする(画像サイズは固定)
        const imgWidth = 500
        const imgHeight = 625
        let offs_front = new OffScreen(imgWidth, imgHeight)
        let offs_back = new OffScreen(imgWidth, imgHeight)
        let offs_tag = new OffScreen(imgWidth, imgHeight * 2)
        offs_front.drawWhite()
        offs_front.drawTrimmingImage(img, 0, 0, img.width, img.height / 2, 0, 0, imgWidth, imgHeight)
        offs_front.drawTrimmingImage(tagmaskimg, 0, 0, tagmaskimg.width, tagmaskimg.height, 0, 0, imgWidth, imgHeight)
        offs_back.drawWhite()
        offs_back.drawUpDownTrimmingImage(img, 0, img.height / 2, img.width, img.height / 2, 0, 0, imgWidth, imgHeight)
        offs_back.drawTrimmingImage(tagmaskimg, 0, 0, tagmaskimg.width, tagmaskimg.height, 0, 0, imgWidth, imgHeight)
        offs_tag.drawWhite()
        offs_tag.drawTrimmingImage(img, 0, 0, img.width, img.height, 0, 0, imgWidth, imgHeight * 2)
        let blobImage_front = await new Promise((resolve, reject) => {
            offs_front.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        let blobImage_back = await new Promise((resolve, reject) => {
            offs_back.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        let blobImage_tag = await new Promise((resolve, reject) => {
            offs_tag.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        return [blobImage_front, blobImage_back, blobImage_tag]
    }
    static async getTagBlobsFromUrl(url) {
        let img = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = url;
        });
        let tagmaskimg = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = require('@/assets/tagmask.png');
        });
        //中央で分割して２マイにする(画像サイズは固定)
        const imgWidth = 500
        const imgHeight = 625
        let offs_front = new OffScreen(imgWidth, imgHeight)
        let offs_back = new OffScreen(imgWidth, imgHeight)
        let offs_tag = new OffScreen(imgWidth, imgHeight * 2)
        offs_front.drawTrimmingImage(img, 0, 0, img.width, img.height / 2, 0, 0, imgWidth, imgHeight)
        offs_front.drawTrimmingImage(tagmaskimg, 0, 0, tagmaskimg.width, tagmaskimg.height, 0, 0, imgWidth, imgHeight)
        offs_back.drawUpDownTrimmingImage(img, 0, img.height / 2, img.width, img.height / 2, 0, 0, imgWidth, imgHeight)
        offs_back.drawTrimmingImage(tagmaskimg, 0, 0, tagmaskimg.width, tagmaskimg.height, 0, 0, imgWidth, imgHeight)
        offs_tag.drawTrimmingImage(img, 0, 0, img.width, img.height, 0, 0, imgWidth, imgHeight * 2)
        let blobImage_front = await new Promise((resolve, reject) => {
            offs_front.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        let blobImage_back = await new Promise((resolve, reject) => {
            offs_back.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        let blobImage_tag = await new Promise((resolve, reject) => {
            offs_tag.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        return [blobImage_front, blobImage_back, blobImage_tag]
    }
    static async getBlobFromFile(file) {
        if (file.type.startsWith("image/")) {
            var src = window.URL.createObjectURL(file);
        }
        let img = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = src;
        });
        let offs = new OffScreen(img.width, img.height)
        offs.drawImage(img, 0, 0, img.width, img.height)
        let blobImage = await new Promise((resolve, reject) => {
            offs.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        return blobImage
    }

    static async getBlobFromUrl(url) {
        this.log(url)
        let img = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = url;
        });
        let offs = new OffScreen(img.width, img.height)
        offs.drawImage(img, 0, 0, img.width, img.height)
        let blobImage = await new Promise((resolve, reject) => {
            offs.toBlob((bimg) => {
                if (bimg) {
                    resolve(bimg)
                } else {
                    reject(null)
                }
            })
        });
        return blobImage
    }
    static async getTagPath(data) {
        let retval = []
        if (!data["fileName"]) {
            retval.push(require("@/assets/tagsample.png"))
            retval.push(require("@/assets/tagsample.png"))
        } else {
            let fileName_front = "tagfront_" + data["fileName"];
            let fileName_back = "tagback_" + data["fileName"];
            let fileName_tag = "tag_" + data["fileName"];
            var url = await FirebaseCommon.getImageUrl(fileName_front);
            retval.push(url)
            url = await FirebaseCommon.getImageUrl(fileName_back);
            retval.push(url)
            url = await FirebaseCommon.getImageUrl(fileName_tag);
            retval.push(url)
        }
        return retval
    }
    static async getTagPathFromTemplateName(taglist, productId, template, material, size) {
        if (template == 'Sample') {
            let isHit = false;
            for (let key in taglist) {
                let data = taglist[key];
                if (
                    data["material"] == material &&
                    data["size"] == size &&
                    data["templateName"] == template &&
                    data["productId"] == productId
                ) {
                    let urls = await Common.getTagPath(data);
                    isHit = true
                    return urls[2]
                }
            }
            if (!isHit) {
                // p.frontTagPath = require(`@/assets/defaulttag/tagfront_default_${material}_${p.categoryData["classcategory_id2"]}.png`);
                // p.backTagPath = require(`@/assets/defaulttag/tagback_default_${material}_${p.categoryData["classcategory_id2"]}.png`);
                // return require(`@/assets/defaulttag/tag_default_${material}_${size}.png`);
                return ""

            }

        }
        for (let key in taglist) {
            let data = taglist[key];
            if (
                data["material"] == material &&
                data["size"] == size &&
                data["templateName"] == template &&
                data["productId"] == productId
            ) {
                let urls = await Common.getTagPath(data);
                return urls[2]
            }
        }
        return ""
    }
    static log(str) {
        // if (config.isDebug) {
        console.log(str)
        // }
    }

    static errorProcess(error) {
        switch (error) {
            case 0:
                alert("通信エラーが発生しました")
                break
            default:
                alert("エラーが発生しました")
                break
        }
    }
    /**
     * 税率
     */
    static getTax() {
        return 0.1
    }

    /**
     * 送料
     */
    static getDelivPrice(itemCount, code) {
        let remaingCount = itemCount
        let price = 0

        while (remaingCount > 0) {
            if (code == 1 || code == 47) {
                if (remaingCount >= 100) {
                    price += 3356
                    remaingCount -= 50
                    continue
                }

                if (remaingCount > 50 && remaingCount < 100) {
                    price += 3356
                    remaingCount = 0
                    break
                }
                if (remaingCount > 30 && remaingCount <= 50) {
                    price += 2342
                    remaingCount = 0
                    break
                }
                if (remaingCount > 15 && remaingCount <= 30) {
                    price += 1780
                    remaingCount = 0
                    break
                }
                if (remaingCount > 5 && remaingCount <= 15) {
                    price += 1450
                    remaingCount = 0
                    break
                }
                if (remaingCount > 0 && remaingCount <= 5) {
                    price += 1168
                    remaingCount = 0
                    break
                }
            } else {
                if (remaingCount >= 50) {
                    price += 1540
                    remaingCount -= 50
                    continue
                }

                if (remaingCount > 30 && remaingCount < 50) {
                    price += 1540
                    remaingCount = 0
                    break
                }
                if (remaingCount > 15 && remaingCount <= 30) {
                    price += 1126
                    remaingCount = 0
                    break
                }
                if (remaingCount > 5 && remaingCount <= 15) {
                    price += 825
                    remaingCount = 0
                    break
                }
                if (remaingCount > 0 && remaingCount <= 5) {
                    price += 598
                    remaingCount = 0
                    break
                }
            }

        }
        return price
    }

    /**
     * カテゴリID(カラー)がどの素材に属するか
     * @param {プロダクトID} productId 
     * @param {カテゴリID} catId 
     */
    static getMaterialFromCategoryId(productId, catId) {
        for (let key in MaterialList[productId]) {
            if (MaterialList[productId][key].indexOf(Number(catId)) !== -1) {
                return key
            }
        }
    }

    static getStringFromDate(date) {

        var year_str = date.getFullYear();
        //月だけ+1すること
        var month_str = 1 + date.getMonth();
        var day_str = date.getDate();
        var hour_str = date.getHours();
        var minute_str = date.getMinutes();
        var second_str = date.getSeconds();


        let format_str = 'YYYY-MM-DD hh:mm:ss';
        format_str = format_str.replace("YYYY", year_str);
        format_str = format_str.replace("MM", month_str);
        format_str = format_str.replace("DD", day_str);
        format_str = format_str.replace("hh", hour_str);
        format_str = format_str.replace("mm", minute_str);
        format_str = format_str.replace("ss", second_str);

        return format_str;
    }

    static getDateStringFromDate(date) {

        var year_str = date.getFullYear();
        //月だけ+1すること
        var month_str = 1 + date.getMonth();
        var day_str = date.getDate();


        let format_str = 'YYYY-MM-DD';
        format_str = format_str.replace("YYYY", year_str);
        format_str = format_str.replace("MM", month_str);
        format_str = format_str.replace("DD", day_str);

        return format_str;
    }

    // オプション品の原価に一律でかける価格
    static getOptionPriceRate() {
        return 3.0;
    }

    static fbmessageToJp(e) {
        switch (e.code) {
            case 'auth/cancelled-popup-request':
            case 'auth/popup-closed-by-user':
                return null;
            case 'auth/email-already-in-use':
                return 'このメールアドレスは使用されています';
            case 'auth/invalid-email':
                return 'メールアドレスの形式が正しくありません';
            case 'auth/user-disabled':
                return 'サービスの利用が停止されています';
            case 'auth/user-not-found':
                return 'メールアドレスまたはパスワードが違います';
            case 'auth/user-mismatch':
                return 'メールアドレスまたはパスワードが違います';
            case 'auth/weak-password':
                return 'パスワードは6文字以上にしてください';
            case 'auth/wrong-password':
                return 'メールアドレスまたはパスワードが違います';
            case 'auth/popup-blocked':
                return '認証ポップアップがブロックされました。ポップアップブロックをご利用の場合は設定を解除してください';
            case 'auth/operation-not-supported-in-this-environment':
            case 'auth/auth-domain-config-required':
            case 'auth/operation-not-allowed':
            case 'auth/unauthorized-domain':
                return '現在この認証方法はご利用頂けません';
            case 'auth/requires-recent-login':
                return '認証の有効期限が切れています';
            default:
                return 'エラーが発生しました。しばらく時間をおいてお試しください';
        }
    }
    static isInValidEmail(email) {
        //メールアドレスとして判定される文字列と記号の組み合わせを定数化
        const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
        //指定した組み合わせになっていなかった場合判定を返す。
        return !reg.test(email);
    }


}
export { ToolButtonType, ToolButtonData, Common, C02ProductParameter }